import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { lastValueFrom } from 'rxjs';
import { SharedModule } from '../../../../common/shared.module';
import { TableContainerComponent } from '../../../../common/components/table-container/table-container.component';
import { TableComponent } from '../../../../common/components/table/table.component';
import { TableColumnDirective } from '../../../../common/directives/table-column.directive';
import TableHeader from '../../../../common/interfaces/table/tableHeader';
import { SwalService } from '../../../../common/services/swal.service';
import { Occupation, OccupationsService } from '../../data-access/occupations.service';
import { OccupationCategoryModalComponent } from '../occupation-category-modal/occupation-category-modal.component';

@Component({
    selector: 'app-occupations-list',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        TableContainerComponent,
        TableComponent,
        TableColumnDirective,
    ],
    templateUrl: './occupations-list.component.html',
    providers: [SwalService],
})
export class OccupationsListComponent implements OnInit {
    occupations: Occupation[] = [];
    filteredOccupations: Occupation[] = [];
    selectedCategory: number | null = null;
    searchTerm: string = '';

    categoryOptions = [
        { label: 'Todas', value: null },
        { label: 'Categoría 1', value: 1 },
        { label: 'Categoría 2', value: 2 },
        { label: 'Categoría 3', value: 3 },
    ];

    tableHeaders: TableHeader[] = [
        { attribute: 'occupationCode', label: 'Código' },
        { attribute: 'occupationDescription', label: 'Descripción' },
        { attribute: 'category', label: 'Categoría' },
    ];

    constructor(
        private occupationsService: OccupationsService,
        private modalService: NgbModal,
        private swal: SwalService
    ) { }

    async ngOnInit() {
        await this.loadOccupations();
    }

    async loadOccupations() {
        this.swal.showLoading('Cargando ocupaciones...');
        try {
            this.occupations = await lastValueFrom(this.occupationsService.getOccupations());
            this.filterOccupations();
        } catch (e) {
            console.error(e);
            this.swal.error('No se pudieron cargar las ocupaciones.');
        } finally {
            this.swal.dismiss();
        }
    }

    filterOccupations() {
        const term = this.searchTerm.trim().toLowerCase();
        this.filteredOccupations = this.occupations.filter((o) => {
            const matchesCategory = this.selectedCategory === null || o.category === this.selectedCategory;
            const matchesSearch = !term ||
                String(o.occupationCode ?? '').toLowerCase().includes(term) ||
                (o.occupationDescription ?? '').toLowerCase().includes(term);
            return matchesCategory && matchesSearch;
        });
    }

    onFilterChange() {
        this.filterOccupations();
    }

    onSearchChange(term: string) {
        this.searchTerm = term;
        this.filterOccupations();
    }

    openModal(occupation: Occupation) {
        const modalRef = this.modalService.open(OccupationCategoryModalComponent, {
            backdrop: 'static',
            centered: true,
        });
        modalRef.componentInstance.occupationCode = occupation.occupationCode;
        modalRef.componentInstance.occupationDescription = occupation.occupationDescription;
        modalRef.componentInstance.currentCategory = occupation.category;

        modalRef.result.then((newCategory) => {
            if (newCategory) {
                occupation.category = newCategory;
                this.swal.success('Categoría actualizada.');
                this.filterOccupations();
            }
        }, () => { });
    }
}
